import { store } from "@/internal";
import axios, { AxiosError, AxiosResponse } from "axios";
import Cookie from "js-cookie";
import qs from "qs";
import HttpService from "./http.service";
import { messagesService } from "./messages.service";

class AuthService extends HttpService {
  private static setCookies(idToken: string, refreshToken: string = ""): void {
    Cookie.set("auth_data", idToken, {
      domain: `${process.env.VUE_APP_COOKIE_DOMAIN}`
    });

    if (refreshToken) {
      Cookie.set("refresh_token", refreshToken, {
        domain: `${process.env.VUE_APP_COOKIE_DOMAIN}`
      });
    }
  }
  public async getToken(code: string): Promise<any> {
    return new Promise(resolve => {
      this.postExternalAsUrlEncoded(code)
        .then(response => {
          AuthService.setCookies(response.access_token, response.refresh_token);
          store.dispatch("authModule/setAccessToken");
          resolve(response.access_token);
        })
        .catch(e => {
          // messagesService.renderErrorMessage(e);
          resolve(false);
        });
    });
  }

  /**
   * @return Promise<Array>
   * @param code
   */
  public async postExternalAsUrlEncoded(code: string): Promise<any> {
    const baseURL = process.env.VUE_APP_OAUTH_URL;
    const payload = {
      code,
      grant_type: "authorization_code",
      redirect_uri: `${process.env.VUE_APP_CORE_FRONTEND}/oauth/callback`,
      client_id: process.env.VUE_APP_OAUTH_CLIENT_ID,
      scopes: process.env.VUE_APP_OAUTH_SCOPES
    };
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          "Basic " +
          btoa(
            `${process.env.VUE_APP_OAUTH_CLIENT_ID}:${
              process.env.VUE_APP_OAUTH_CLIENT_SECRET
            }`
          )
      }
    };
    const instance = axios.create({ baseURL });
    const response: AxiosResponse = await instance.post(
      "/oauth2/token",
      qs.stringify(payload),
      config
    );
    return response.data;
  }

  public async refreshToken(): Promise<string> {
    const isRefreshing = Cookie.get("refreshing");
    if (isRefreshing) {
      return "";
    }
    const baseURL = process.env.VUE_APP_OAUTH_URL;
    const payload = {
      grant_type: "refresh_token",
      client_id: process.env.VUE_APP_OAUTH_CLIENT_ID,
      refresh_token: Cookie.get("refresh_token"),
      scopes: process.env.VUE_APP_OAUTH_SCOPES
    };

    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          "Basic " +
          btoa(
            `${process.env.VUE_APP_OAUTH_CLIENT_ID}:${
              process.env.VUE_APP_OAUTH_CLIENT_SECRET
            }`
          )
      }
    };
    Cookie.set("refreshing", "1", {
      domain: `${process.env.VUE_APP_COOKIE_DOMAIN}`
    });
    const instance = axios.create({ baseURL });
    return await instance
      .post("/oauth2/token", qs.stringify(payload), config)
      .then((response: AxiosResponse) => {
        const newIdToken = response.data.access_token;
        AuthService.setCookies(newIdToken);
        return newIdToken;
      })
      .catch((error: AxiosError) => {
        if (error.response && error.response.status === 400) {
          messagesService.renderWarningMessage("login_accept_error");
        } else {
          messagesService.renderErrorMessage(error);
        }

        return "";
      })
      .finally(() => {
        Cookie.set("refreshing", "", {
          domain: `${process.env.VUE_APP_COOKIE_DOMAIN}`
        });
      });
  }

  public async revokeToken() {
    const baseURL = process.env.VUE_APP_OAUTH_URL;
    const instance = axios.create({ baseURL });
    const token = Cookie.get("refresh_token");
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          "Basic " +
          btoa(
            `${process.env.VUE_APP_OAUTH_CLIENT_ID}:${
              process.env.VUE_APP_OAUTH_CLIENT_SECRET
            }`
          )
      }
    };
    const response = await instance.post(
      `/oauth2/revoke`,
      qs.stringify({
        token
      }),
      config
    );

    return response;
  }
}

export const authService = new AuthService();
